import { defineComponent as _defineComponent } from 'vue'
import { ConfigProvider } from 'ant-design-vue'
// @ts-ignore
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import '@/styles/index.less'
import { onMounted } from 'vue'
import { useAppStore } from './store/app'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useAppStore()
onMounted(() => {
  store.getCurrentInfo()
})

return { __sfc: true,store, ConfigProvider, zhCN }
}

})